import { Constructor } from 'vue-property-decorator'

export const InteractiveComponentPluginSymbol = Symbol.for("InteractiveComponentPluginSymbol");
export type InteractiveComponentPlugin = Constructor

// export enum ResultStatuses {
//   incompleted = 'incompleted',
//   completed = 'completed',
// }
export type ResultStatus = 'incomplete' | 'completed'

export interface Result {
  status: ResultStatus;
  progress: number;
}

export interface InteractiveComponentProps<TState, TContent> {
  // REVIEW: we don't need result in the component itself
  result?: Result | null;
  state: TState | null;
  meta: InteractionComponentMeta;
  content: TContent;
  // TODO: remove props
  //props: TContent;
}

export interface InteractionComponentMeta {
  id: string
  title: string | null
}

export interface InteractiveComponent<TState, TProps> extends InteractiveComponentProps<TState, TProps> {
  emitInteractionResultChanged(): Result
  emitInteractionStateChanged(): TState
}
